import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
axios.defaults.baseURL = process.env.REACT_APP_API_URL;
export const getSampleCollectionListSlice = createAsyncThunk(
  "sampleCollection/list",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "sampleCollection/list",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);
export const updateSampleCollectionSlice = createAsyncThunk(
  "sampleCollection/update",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `/sampleCollection/update`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);
const initialState = {
  loading: false,
  sampleCollectionList: [],
  error: null,
  updateLoading: false,
  updateSuccessMessage: null,
  updateErrorMessage: null,
  currentPage: 1,
  totalPages: null,
  hasMore: true,
  totalCount: 0,
};
const sampleCollectionSlice = createSlice({
  name: "sampleCollection",
  initialState,
  reducers: {
    resetUpdateMessages: (state) => {
      state.updateSuccessMessage = null;
      state.updateErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSampleCollectionListSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSampleCollectionListSlice.fulfilled, (state, action) => {
        state.loading = false;

        if (!action.payload.success) {
          state.sampleCollectionList = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.searchMessage =
            action.payload.result?.message || "No data found";
          return;
        }

        const result = action.payload.result;

        state.sampleCollectionList = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchMessage = null;
      })
      .addCase(getSampleCollectionListSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      .addCase(updateSampleCollectionSlice.pending, (state) => {
        state.updateLoading = true;
      })
      .addCase(updateSampleCollectionSlice.fulfilled, (state, action) => {
        state.updateLoading = false;
        if (action.payload.success) {
          state.updateSuccessMessage = action.payload.message;
        } else {
          state.updateErrorMessage = action.payload.message;
        }
      })
      .addCase(updateSampleCollectionSlice.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateErrorMessage =
          action.payload || "Update failed";
      });
  },
});
export const { resetUpdateMessages } = sampleCollectionSlice.actions;
export default sampleCollectionSlice.reducer;